module.exports = __webpack_public_path__ + "img/monitor.16e58c1e.svg";